import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfigurationDTO } from "~/features/configurator/Linear/dtos";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import type { ConfiguratorUpdateCommand } from "~/features/configurator/common/api/configuratorCommands";
import { postConfiguratorCommand } from "~/features/configurator/common/api/configuratorCommandApi";

export async function sendLinear(data: ConfiguratorUpdateCommand): Promise<LinearConfiguration> {
  const response = await postConfiguratorCommand<LinearConfigurationDTO>(
    "/cpq/getconfig",
    data,
    "sending linear update",
  );
  return transform(response, ConfiguratorType.System, undefined);
}
